module.exports = __webpack_public_path__ + "static/media/ic_empty_swatchlib.15849c1a.svg";